// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2001":"17d2ede36b187547","7848":"a954bca41cfc6ce5","8529":"fde45b7613fcfbbc","8818":"3b832f2b11d2456e"}[chunkId] + ".css";
};